import { mapGetters } from 'vuex';
export default {
  name: 'Logo',
  props: {
    // Logo链接地址（可被用户配置覆盖）
    href: {
      type: String,
      default: 'https://github.com/MarSeventh/CloudFlare-ImgBed'
    },
    // 链接打开方式
    target: {
      type: String,
      default: '_blank',
      // _blank, _self, _parent, _top
      validator: value => ['_blank', '_self', '_parent', '_top'].includes(value)
    },
    // 图片alt文本
    alt: {
      type: String,
      default: 'Sanyue logo'
    },
    // 自定义logo图片URL（可选）
    customSrc: {
      type: String,
      default: ''
    },
    // Logo位置样式
    position: {
      type: String,
      default: 'fixed',
      // fixed, relative, absolute
      validator: value => ['fixed', 'relative', 'absolute', 'static'].includes(value)
    },
    // Logo大小
    size: {
      type: String,
      default: 'normal',
      // small, normal, large
      validator: value => ['small', 'normal', 'large'].includes(value)
    },
    // 是否启用悬停动画
    enableHover: {
      type: Boolean,
      default: true
    },
    // 是否允许使用用户配置的链接（仅上传页面启用）
    useConfigLink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['userConfig']),
    logoUrl() {
      // 优先级：customSrc > 用户配置 > 默认图片
      return this.customSrc || this.userConfig?.logoUrl || require('../assets/logo.png');
    },
    logoHref() {
      // 只有启用 useConfigLink 时才使用用户配置的链接
      if (this.useConfigLink && this.userConfig?.logoLink) {
        return this.userConfig.logoLink;
      }
      return this.href;
    },
    logoClasses() {
      return {
        'logo': true,
        [`logo--${this.position}`]: true,
        [`logo--${this.size}`]: true,
        'logo--hover-enabled': this.enableHover
      };
    }
  }
};